import { blue, green } from "@ant-design/colors";
import { CheckOutlined } from "@ant-design/icons";
import { Button, Flex, Row, Space, Typography } from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification } from "common";
import Prefixs from "common/Prefixs";
import { formatterNumber } from "helpers/formatNumber";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function SuccessExtend({ setLoading, dataCheckReq, dataCert }) {
  const [dataPayment, setDataPayment] = useState();
  const history = useHistory();

  const fetchDataPayment = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.getInformationOrder({
        object: dataCheckReq.object,
        requestId: dataCheckReq.id,
        type: dataCert.type,
      });
      if (res && res.status === 200 && res.data.data) {
        setDataPayment(res.data.data);
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCheckReq, dataCert]);

  return (
    <Flex justify="center" align="center" className="my-5">
      <Space direction="vertical" align="center">
        <Flex justify="center">
          <Button
            type="primary"
            style={{ background: green.primary }}
            shape="circle"
            size="large"
            icon={<CheckOutlined />}
          />
        </Flex>
        <Typography.Title level={4}>
          Yêu cầu đã gửi thành công đến FastCA
        </Typography.Title>

        <div className="">
          <div>
            Để thực hiện
            <Typography.Text strong> gia hạn </Typography.Text>
            chứng thư số USB Token thành công, Quý khách vui lòng thực hiện các
            bước sau:
          </div>
          <Space direction="vertical" className="ml-5">
            <div>
              {" "}
              <Typography.Text strong>Bước 1: </Typography.Text>
              Thực hiện thanh toán phí gia hạn dịch vụ là 
              <Typography.Text strong style={{ fontSize: "1.1rem" }}>
                {" "}
                {formatterNumber(dataPayment?.totalPayment)} VNĐ{" "}
              </Typography.Text>
              (Đã bao gồm VAT)
            </div>
            <div>
              <Typography.Text strong>Bước 2: </Typography.Text>
              Kiểm tra kết quả xử lý yêu cầu Gia hạn chứng thư số được gửi về
              Email của Quý khách, trong thời gian 02 giờ làm việc kể từ thời
              điểm thanh toán phí hoàn tất
            </div>
            <div>
              <Typography.Text strong>Bước 3: </Typography.Text>
              Rút token cắm lại để cập nhật chứng thư số đã Gia hạn
            </div>
            <div>
              <Typography.Text strong>Bước 4: </Typography.Text>
              Gửi yêu cầu xuất hóa đơn VAT đến FastCA (trong 24 giờ) và nhận hóa
              đơn dịch vụ
            </div>
            <div>
              <Typography.Text strong>Bước 5: </Typography.Text>
              Cập nhật <Typography.Text strong>
                {" "}chứng thư số mới{" "}
                </Typography.Text> vào các tài khoản dịch vụ công (như Thuế,
              Bảo hiểm xã hội, Hải quan, Đấu thầu, Hóa đơn,…) và các ứng dụng
              dịch vụ phần mềm có sử dụng chứng thư số để tránh gián đoạn trong
              quá trình sử dụng
            </div>
          </Space>
          <br />
          <br />
          <div>
            Trường hợp không nhận được kết quả hoặc thực hiện không thành công,
            Quý khách vui lòng liên hệ FastCA để được hỗ trợ nhanh chóng kịp
            thời
          </div>
          <br />
          <div>
            Bằng việc nhấn
            <Typography.Text strong style={{ color: blue.primary }}>
              {" "}
              Tiếp tục{" "}
            </Typography.Text>
            Quý khách đồng ý với
            <Typography.Text strong>
              {" "}
              Chính sách đặt hàng và thanh toán{" "}
            </Typography.Text>
            của FastCA, xem chi tiết
            <Typography.Text strong>
              <Typography.Link
                href={`${dataPayment?.urlChinhSach}`}
                target="_blank"
              >
                {" "}
                TẠI ĐÂY
              </Typography.Link>
              .
            </Typography.Text>
          </div>
        </div>
        <br />
        <Row>
          <Typography.Text strong>
            <Link
              to={`${Prefixs.ORDER_PAYMENT}?object=${dataCheckReq.object}&type=${dataCert?.type}&requestId=${dataCheckReq.id}`}
            >
              <Button type="primary" htmlType="submit">
                Tiếp tục
              </Button>
            </Link>
          </Typography.Text>
        </Row>
      </Space>
    </Flex>
  );
}
